import { injectable } from 'inversify';
import { Arr } from '../../../../CodesForFoundation';
import { Component, ObjectManager } from '../../../../concepts/objects';
import { EditorSession } from '../../../canvas/EditorSession';
import { Physical } from '../../../canvas/entities/Physical';
import { Selection } from '../../../canvas/Selection';
import { resolve } from '../../../Container';
import { ExportSource, ExportSourceProvider } from '../ExportSource';

export class FromWholeBoardExportSource implements ExportSource {

    constructor(private objects: ObjectManager) {
    }

    public readonly id = 'everything';
    public readonly label = 'Whole Board';
    public readonly default = true;

    public canRead() {
        return true;
    }

    public read(): Component[] {
        return Array.from(this.objects.getAll(Physical));
    }

    public stats(types: string[]): Readonly<Record<string, number>> {
        const lookup = Arr.groupBy(this.read(), 'type');
        return Object.fromEntries(types.map(x => [x, (lookup[x] ?? []).length]));
    }
}

class FromSelectionExportSource implements ExportSource {

    constructor(private session: EditorSession) {
    }

    public readonly id = 'selection';
    public readonly label = 'Selection';
    public readonly default = true;

    public canRead(): boolean {
        return this.session.get(Selection).size > 0;
    }

    public read(): Component[] {
        return Array.from(new Set(
            Array.from(this.session.get(Selection))
                .flatMap(x => x.flatten(true))
                .filter(x => x.is(Physical))
        ));
    }

    public stats(types: string[]): Readonly<Record<string, number>> {
        const lookup = Arr.groupBy(this.read(), 'type');
        return Object.fromEntries(types.map(x => [x, (lookup[x] ?? []).length]));
    }
}

@injectable()
export class StandardExportSourceProvider implements ExportSourceProvider {

    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(EditorSession) private session: EditorSession;

    public readonly id = 'Standard';

    public get = () => [
        new FromSelectionExportSource(this.session),
        new FromWholeBoardExportSource(this.objects),
    ];
}
